import axios from "axios";
import { Code, Entity, Repository } from "@/types";

const { mergeWith } = require("lodash");

export let all: Code[] = [];

export let excludes: { [key: string]: string[] } = {};

export const repository = new Repository<Entity<string>>();

axios.get("/data/icds.d48b37c14e.json").then(response => {
  const imported = response.data as {
    codes: Entity<string>[];
    [key: string]: Entity<string>[];
  };

  for (let key of Object.keys(imported).filter(key => key !== "codes")) {
    imported[key].forEach((entity: Entity<string>) => {
      if (entity.inherits) {
        entity.inherits = entity.inherits.map(e =>
          repository.get(e.type, e.id)
        ) as Entity<string>[];
      }
      repository.add(key, entity);
    });
  }

  imported.codes.forEach((entity: Entity<string>, index: number) => {
    repository.add("codes", {
      ...entity,
      index,
      inherits: (entity.inherits || []).map(e =>
        repository.get(e.type, e.id)
      ) as Entity<string>[],
      level: Math.max(0, entity.id.length - 4)
    });
  });

  all = repository.all("codes") as Code[];
});

import("@/assets/excludes.json").then(data => {
  excludes = data.default as { [key: string]: string[] };
});

export class EntityHelper {
  static inherits(raw: Entity<string>): Set<Entity<string>> {
    return new Set(
      raw.inherits
        ? [
            ...raw.inherits,
            ...raw.inherits.map(e => [...EntityHelper.inherits(e)]).flat()
          ]
        : []
    );
  }

  static track(
    raw: Entity<string>
  ): Entity<{
    value: string;
    source: Entity<string>;
  }> {
    return {
      ...raw,
      attributes: Object.assign(
        {},
        ...Object.entries(raw.attributes).map(([key, value]) => ({
          [key]:
            key in raw.attributes
              ? value.map((note: string) => ({ value: note, source: raw }))
              : value
        }))
      )
    };
  }

  static parsed(
    raw: Entity<string>
  ): Entity<{
    value: string;
    source: { value: Entity<string>; type: string };
  }> {
    return mergeWith(
      {},
      ...[...EntityHelper.inherits(raw)].map(e => EntityHelper.track(e)),
      EntityHelper.track(raw),
      (destination: any, source: any) => {
        if (Array.isArray(destination)) {
          return destination.concat(source);
        }
      }
    );
  }
}
